var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel advantages" }, [
    _c("h2", { staticClass: "panel__title" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("checkout:global.advantages.title")) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "check-list" }, [
      this.$api.data.region.shortName === "EU"
        ? _c(
            "li",
            [
              _c("font-awesome-icon", {
                directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
                attrs: { icon: _vm.icon, size: "2x" },
              }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("checkout:global.advantages.germany_first")) +
                  "\n    "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("font-awesome-icon", {
            directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
            attrs: { icon: _vm.icon, size: "2x" },
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("checkout:global.advantages.support")) +
              "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("font-awesome-icon", {
            directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
            attrs: { icon: _vm.icon, size: "2x" },
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("checkout:global.advantages.webinterface")) +
              "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("font-awesome-icon", {
            directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
            attrs: { icon: _vm.icon, size: "2x" },
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("checkout:global.advantages.flexibility")) +
              "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("font-awesome-icon", {
            directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
            attrs: { icon: _vm.icon, size: "2x" },
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("checkout:global.advantages.three_minutes")) +
              "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("font-awesome-icon", {
            directives: [{ name: "fancy-color", rawName: "v-fancy-color" }],
            attrs: { icon: _vm.icon, size: "2x" },
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("checkout:global.advantages.secure_payment")) +
              "\n    "
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }